import { getCurrentToken, getTokenFromQueryString } from './auth';

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

function errorWithResponse(response, json = null) {
  const error = new Error(response.statusText);
  if (json) {
    error.json = json;
    if (json.errors) {
      error.errors = json.errors;
    } else if (json.error) {
      error.errors = { messages: [json.error] };
    }
  }
  if (!error.errors) {
    error.errors = { messages: [response.statusText] };
  }
  if (response.status >= 500) {
    error.global = true;
  }
  error.response = response;
  return error;
}

export function request(path, options = {},
  config = { auth: true, verbose: false, formData: false }) {
  const newOptions = options;
  const urlPath = path.startsWith('/') ? path : `/api/${path}`;

  if (!config.formData) {
    newOptions.headers = Object.assign({}, DEFAULT_HEADERS, newOptions.headers);
  } else {
    newOptions.headers = {};
  }

  if (config.auth) {
    const token = getTokenFromQueryString() || getCurrentToken();
    Object.assign(newOptions.headers, { Authorization: `Bearer ${token}` });
  }
  if (newOptions.headers['Content-Type'] === 'application/json' &&
    newOptions.body && typeof newOptions.body === 'object') {
    newOptions.body = JSON.stringify(newOptions.body);
  }
  if (config.verbose) {
    console.info('Request to ', // eslint-disable-line no-console
      urlPath,
      ' with options ',
      JSON.stringify(newOptions, null, '\t',
    ));
  }

  return fetch(urlPath, newOptions)
  .catch((e) => {
    const error = new Error(e);
    error.global = true;
    error.errors = { messages: ['Could not connect to SPOT, please check your internet connection'] };
    error.response = null;
    throw error;
  })
  .then(response => response.json()
    .catch(() => { throw errorWithResponse(response); })
    .then((json) => {
      if (!response.ok) {
        throw errorWithResponse(response, json);
      }
      return { response, json };
    }),
  );
}

export function requestNoAuthentication(url, options, config) {
  const cf = Object.assign({}, config, { auth: false });
  return request(url, options, cf);
}

export function update(entity, data, theEntity) {
  // this doesn't let proper updates for nested entities urls
  return request(`${entity}s/${data.id}`, {
    method: 'PUT',
    body: { [theEntity || entity]: data },
  });
}

export function create(entity, data, extra) {
  return request(`${entity}s/`, {
    method: 'POST',
    body: { [entity]: data, ...extra },
  });
}

export function upload(formData, entity) {
  return request(`${entity}/`, {
    method: 'POST',
    body: formData,
  }, {
    formData: true,
    auth: true,
  });
}



// WEBPACK FOOTER //
// ./client/app/services/api.js